import classNames from 'classnames'

import { RenderWhen } from 'cng-common/components/renderWhen'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Checkbox } from 'core-components/library/checkbox'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'

import styles from './Navigation.module.scss'

interface IProps {
  id: string
  isActive?: boolean
  isCompleted?: boolean
  title: string
  subTitle?: string
  onStepChange: () => void
  isChanged: boolean
  isEnabled?: boolean
  isToggleable?: boolean
  onTabToggleChange?: (pageId: string, value: boolean) => void
}

export const NavigationItem = ({
  title,
  isActive,
  isCompleted,
  onStepChange,
  subTitle,
  isChanged,
  isEnabled,
  isToggleable,
  onTabToggleChange,
  id,
}: IProps) => {
  return (
    <a
      onClick={onStepChange}
      className={classNames(styles.item, {
        [styles['item_active']]: isActive,
        [styles['item_completed']]: isCompleted,
      })}
    >
      <span className={styles.item__inner}>
        <div className={styles.item__title}>
          <Translation text={title} />
          {isChanged ? '*' : null}
        </div>
        {subTitle ? (
          <div>
            <Translation text={getFormedEltTranslation('meetings-export-conditionals')} />
          </div>
        ) : null}
      </span>
      <RenderWhen condition={Boolean(isToggleable)}>
        <div className={styles.item__checkbox} onClick={(e) => e.stopPropagation()}>
          <Checkbox
            checked={Boolean(isEnabled)}
            onChange={(flag) => {
              if (onTabToggleChange) {
                onTabToggleChange(id, flag)
              }
            }}
            className={classNames({ [styles.item__checkbox_active]: isEnabled })}
          />
        </div>
      </RenderWhen>
    </a>
  )
}
